// extracted by mini-css-extract-plugin
module.exports = {"emarsys_form":"Emarsys_emarsys_form___UHmj"};